
import { PurchaseEvent } from '@/usecases/event-bus-for-third-party/event'
import { executeConversionTag as executeCribnotesConversionTag } from '@spa/vendor/cribnotes'

export function sendToCribnotes(event: PurchaseEvent): void {
  const { orderResultSuccessList } = event

  orderResultSuccessList.forEach((result) => {
    const items = result.order.cartItems.map(item => ({
      item_id: item.skuId,
      price: item.unitPrice,
      quantity: item.unitCount,
    }))

    executeCribnotesConversionTag(result.commerceSalesOrder.compressedShortId, items)
  })
}
